import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CookiesService {

    constructor() { }

    /**
     * Returns the value of given cookie key
     * @param name name of the cookie
     * @param wasEncoded flag for encoded content
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-01-21
     */
    public getCookie(name: string, wasEncoded: boolean = false) {
        const ca: Array<string> = document.cookie.split(';');
        const caLen: number = ca.length;
        const cookieName = `${name}=`;
        let c: string;

        for (let i = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, '');
            if (c.indexOf(cookieName) === 0) {
                if (wasEncoded) {
                    return atob(c.substring(cookieName.length, c.length));
                }
                return c.substring(cookieName.length, c.length);
            }
        }
        return '';
    }

    /**
     * Remove given cookie
     * @param name name of the cookie
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-01-21
     */
    public deleteCookie(name: string) {
        this.setCookie(name, '', -1, false);
    }

    /**
     * Sets a value for given cookie key
     * @param name name of the key
     * @param value value for the key
     * @param expireDays expiration time
     * @param encode encode the cookie value flag
     * @param path path
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-01-21
     */
    public setCookie(name: string, value: string, expireDays: number, encode: boolean = false, path: string = '') {
        const d: Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        const expires: string = 'expires=' + d.toUTCString();
        if (encode) {
            value = btoa(value);
        }
        document.cookie = name + '=' + value + '; ' + expires + (path.length > 0 ? '; path=' + path : '');
    }
}
